var _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJira(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5174 9.0384L8.72905 1.25L0.940653 9.0384C0.818555 9.161 0.75 9.32697 0.75 9.5C0.75 9.67302 0.818555 9.83901 0.940653 9.9616L8.72905 17.75L16.5174 9.9616C16.6395 9.83901 16.7081 9.67302 16.7081 9.5C16.7081 9.32697 16.6395 9.161 16.5174 9.0384ZM8.72905 11.9385L6.28974 9.49919L8.72905 7.05988L11.1684 9.49919L8.72905 11.9385Z",
    fill: "#3F8CFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.72906 7.0757C7.96184 6.30858 7.52934 5.26903 7.52601 4.18408C7.52269 3.09914 7.94882 2.05696 8.71134 1.28516L3.35742 6.60524L6.26236 9.51018L8.72906 7.0757Z",
    fill: "url(#paint0_linear_7927_3767)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1748 9.49219L8.729 11.9379C9.11064 12.3193 9.41339 12.7722 9.61995 13.2706C9.8265 13.7691 9.93282 14.3033 9.93282 14.8429C9.93282 15.3824 9.8265 15.9167 9.61995 16.4151C9.41339 16.9136 9.11064 17.3664 8.729 17.7478L14.0781 12.3987L11.1748 9.49219Z",
    fill: "url(#paint1_linear_7927_3767)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7927_3767",
    x1: 8.29405,
    y1: 4.59289,
    x2: 4.88804,
    y2: 7.9989,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#0052CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2684FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_7927_3767",
    x1: 9.19463,
    y1: 14.3773,
    x2: 12.5942,
    y2: 10.9777,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#0052CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2684FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJira);
export default __webpack_public_path__ + "static/media/jira.fc27f8bcc016c3e21499b11810ece229.svg";
export { ForwardRef as ReactComponent };